var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscuss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 25C4 13.402 13.402 4 25 4s21 9.402 21 21-9.402 21-21 21H7.111A3.111 3.111 0 0 1 4 42.889V25Z",
    fill: "#F86126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.767 45.696C23.95 43.356 38 27.819 38 9c0-.166-.001-.331-.003-.496A20.91 20.91 0 0 0 25 4C13.402 4 4 13.402 4 25v17.889c0 1.237.722 2.305 1.767 2.807Z",
    fill: "#F78613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscuss);
export default __webpack_public_path__ + "static/media/Discuss.09ba2c16c6a61ad69507e9a7642e0cd7.svg";
export { ForwardRef as ReactComponent };